import React, {useEffect, useState} from 'react';

import styles from './MobileCartPage.module.css'

import {Steps} from "../../../../ui/Navigation/Steps/Steps.tsx";
import {StepStatus} from "../../../../ui/Navigation/Steps/types/StepStatusEnum.ts";
import {MobileCartProducts} from "../../components/CartProducts/Mobile/MobileCartProducts.tsx";
import {MobileCartDelivery} from "../../components/CartDelivery/Mobile/MobileCartDelivery.tsx";
import {CartPaymentMethods} from "../../components/CartPaymentMethods/CartPaymentMethods.tsx";
// import {CartExtraInfo} from "../../components/CartExtraInfo/CartExtraInfo.tsx";
import {Button} from "../../../../ui/General/Button/Button.tsx";
import {arrowLeft2Icon} from "../../../../assets/icons/icons.ts";
import {Order} from "../../../../types/Order.interface.ts";
import {Address} from "../../../../types/Delivery.interface.ts";
import {LoginWarning} from "../../../../widgets/LoginWarning/LoginWarning.tsx";

interface Props {
    cartOffer: Order|null,
    isAuth: boolean,
    onPaymentMethodChange: (variant: string) => void,
    onDeliveryTypeChange: (type: string) => void,
    onDeliveryTransportCompanyChange: (transportCompanyId: number) => void,
    addOrLessenProduct: (elementId: number, operation: ProductOperation) => void,
    removeProducts: (ids: number[]) => void,
    createOrder: (withBonuses: boolean) => Promise<Response>,
    setIsOpenChangeTownModal: (isOpenChangeTownModal: boolean) => void,
    onDeliveryAddressChange: (address: Address) => void,
}

type ProductOperation = 'add' | 'remove'

export const MobileCartPage: React.FC<Props> = ({
                                                    cartOffer,
                                                    onPaymentMethodChange,
                                                    onDeliveryTypeChange,
                                                    onDeliveryTransportCompanyChange,
                                                    createOrder,
                                                    addOrLessenProduct,
                                                    removeProducts,
                                                    setIsOpenChangeTownModal,
                                                    onDeliveryAddressChange,
                                                    isAuth,
                                                }) => {

    const steps = [
        {title: 'Способ получения', status: StepStatus.wait},
        {title: 'Способ оплаты', status: StepStatus.process},
        {title: 'Подтверждение заказа', status: StepStatus.finish},
    ];

    const [stepKey, setStepKey] = useState(0);
    const [isOrderPlaced, setIsOrderPlaced] = useState(false)
    const current = steps[stepKey];
    const next = () => {
        if(stepKey < (steps.length - 1)) setStepKey(stepKey + 1);
    }
    const prev = () => {
        if(stepKey > 0) setStepKey(stepKey - 1);
    }

    useEffect(() => {

    }, [cartOffer]);

    return (
        <div className={styles.wrapper}>
            {!isAuth && <LoginWarning />}
            {isOrderPlaced && current.status !== StepStatus.finish && (<>
                <div className={styles.steps}>
                    <Steps steps={steps} currentStatus={current.status}/>
                </div>
                <div className={styles.outline}/>
            </>)}
            {!isOrderPlaced  && cartOffer && (
                <MobileCartProducts
                    addOrLessenProduct={addOrLessenProduct}
                    removeProducts={removeProducts}
                    cartOffer={cartOffer}
                    createOrder={createOrder}
                    setIsOrderPlaced={setIsOrderPlaced}
                    isOrderPlaced={isOrderPlaced}
                    isAuth={isAuth}
                />
            )}
            {
                isOrderPlaced && current.status === StepStatus.finish && cartOffer
                ? <>
                    <Button className={styles.btnReturn} type='text' onClick={prev}>
                        <img src={arrowLeft2Icon} alt='Стрелка назад' />
                        Вернуться назад
                    </Button>
                    <MobileCartProducts
                        addOrLessenProduct={addOrLessenProduct}
                        removeProducts={removeProducts}
                        cartOffer={cartOffer}
                        createOrder={createOrder}
                        setIsOrderPlaced={setIsOrderPlaced}
                        isOrderPlaced={isOrderPlaced}
                        isAuth={isAuth}
                    />
                </>
                : null
            }

            {
                isOrderPlaced && current.status === StepStatus.wait && cartOffer
                ?   <>
                        <Button className={styles.btnReturn} type='text' onClick={() => {
                            setIsOrderPlaced(false)
                            prev()
                        }}>
                            <img src={arrowLeft2Icon} alt='Стрелка назад' />
                            Вернуться назад
                        </Button>
                        <MobileCartDelivery
                            onDeliveryTypeChange={onDeliveryTypeChange}
                            onDeliveryTransportCompanyChange={onDeliveryTransportCompanyChange}
                            offer={cartOffer}
                            setIsOpenChangeTownModal={setIsOpenChangeTownModal}
                            onDeliveryAddressChange={onDeliveryAddressChange}
                        />
                        <Button
                            className={styles.btnContinueOrder}
                            type='regular'
                            onClick={() => next()}
                        >
                            Продолжить оформление
                        </Button>
                    </>
                : null
            }

            {
                isOrderPlaced && current.status === StepStatus.process && cartOffer
                    ? <>
                        <Button className={styles.btnReturn} type='text' onClick={prev}>
                            <img src={arrowLeft2Icon} alt='Стрелка назад' />
                            Вернуться назад
                        </Button>
                        <CartPaymentMethods onMethodChange={onPaymentMethodChange} cartOffer={cartOffer}/>
                        {/* <CartExtraInfo /> */}
                        <Button
                            className={styles.btnContinueOrder}
                            type='regular'
                            onClick={() => next()}
                        >
                            Продолжить оформление
                        </Button>
                    </>
                 : null
            }
        </div>
    );
};